import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=e7c1272c&scoped=true&"
import script from "./LinkedIn.vue?vue&type=script&lang=js&"
export * from "./LinkedIn.vue?vue&type=script&lang=js&"
import style0 from "./LinkedIn.scss?vue&type=style&index=0&id=e7c1272c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c1272c",
  null
  
)

export default component.exports